import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container px-0" }
const _hoisted_2 = { class: "container-fluid py-3 page-main-title" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col text-center page-main-title" }
const _hoisted_5 = { class: "white-text" }
const _hoisted_6 = { class: "col-md-9 col-lg-10 px-md-4" }
const _hoisted_7 = { class: "container py-3" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-6 py-3" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "col-12 text-center text-lg-start py-3" }
const _hoisted_12 = { class: "hc1 bold" }
const _hoisted_13 = { class: "col-12 p-4 bg-grey" }
const _hoisted_14 = { class: "grey-text" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = { class: "grey-text" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-12 p-4" }
const _hoisted_19 = { class: "grey-text" }
const _hoisted_20 = {
  key: 0,
  class: "row"
}
const _hoisted_21 = { class: "col-12 p-4" }
const _hoisted_22 = ["innerHTML"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "col-12 p-4" }
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "row"
}
const _hoisted_28 = { class: "col-12 p-4" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "col-12 p-4" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["src"]
const _hoisted_34 = { class: "col-12 p-4" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "col-12 p-4" }
const _hoisted_38 = ["innerHTML"]
const _hoisted_39 = ["src"]
const _hoisted_40 = { class: "col-12 p-4" }
const _hoisted_41 = ["innerHTML"]
const _hoisted_42 = ["src"]
const _hoisted_43 = {
  key: 2,
  class: "row"
}
const _hoisted_44 = { class: "col-12 p-4" }
const _hoisted_45 = ["innerHTML"]
const _hoisted_46 = ["src"]
const _hoisted_47 = { class: "col-12 p-4" }
const _hoisted_48 = ["innerHTML"]
const _hoisted_49 = ["src"]
const _hoisted_50 = {
  ref: "downloadContainer",
  style: {"display":"none"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_error_tips = _resolveComponent("error-tips")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString($setup.locale.windows10), 1)
          ])
        ])
      ]),
      _createElementVNode("main", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Breadcrumb, {
                class: "grey-text",
                item_one_title: $setup.locale.windows11,
                item_one_active: true,
                loading: $setup.data.loading
              }, null, 8, ["item_one_title", "loading"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, _toDisplayString($setup.locale.windows11), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", _hoisted_14, _toDisplayString($setup.locale.windows12), 1),
              _hoisted_15,
              _createElementVNode("span", _hoisted_16, _toDisplayString($setup.locale.windows13), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("span", _hoisted_19, _toDisplayString($setup.locale.windows14), 1),
              _createElementVNode("a", {
                href: "/tutorials/windows?page=1&p=2",
                onMouseover: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==1 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.windows15), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/windows?page=2&p=2",
                onMouseover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==2 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.windows16), 3)
              ], 32),
              _createElementVNode("a", {
                href: "/tutorials/windows?page=3&p=2",
                onMouseover: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.handleMouseOver && $setup.handleMouseOver(...args))),
                onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.handleMouseLeave && $setup.handleMouseLeave(...args)))
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass($setup.data.page==3 /* && !data.hover */?'btn-tutorial-tab-title  btn-selected':'btn-tutorial-tab-title')
                }, _toDisplayString($setup.locale.windows17), 3)
              ], 32)
            ])
          ]),
          ($setup.data.page==1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows18
                  }, null, 8, _hoisted_22),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[0],
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[0]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_23)
                ]),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows19
                  }, null, 8, _hoisted_25),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[1],
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[1]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_26)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows20
                  }, null, 8, _hoisted_29),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[2],
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[2]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_30)
                ]),
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows21
                  }, null, 8, _hoisted_32),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[3],
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[3]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_33)
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows22
                  }, null, 8, _hoisted_35),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[4],
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[4]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_36)
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows23
                  }, null, 8, _hoisted_38),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[5],
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[5]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_39)
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows24
                  }, null, 8, _hoisted_41),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[6],
                    onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[6]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_42)
                ])
              ]))
            : _createCommentVNode("", true),
          ($setup.data.page==3)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows25
                  }, null, 8, _hoisted_45),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[7],
                    onClick: _cache[13] || (_cache[13] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[7]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_46)
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("span", {
                    innerHTML: $setup.locale.windows26
                  }, null, 8, _hoisted_48),
                  _createElementVNode("img", {
                    class: "img-fluid image-border",
                    src: $setup.data.images[8],
                    onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.openImageInNewTab($setup.data.images[8]))),
                    alt: "windows_tutorial"
                  }, null, 8, _hoisted_49)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_50, null, 512)
      ])
    ]),
    _createVNode(_component_error_tips, { ref: "errorRef" }, null, 512)
  ], 64))
}